import { observer } from 'mobx-react';
import PersonPhoto from '../../../../../../../../PersonPhoto';
import { avatarFrom } from '../../../../../../../../../Avatar';
import { NotTranslated } from '../../../../../../../../../Translations';
import { findLink } from '../../../../../../../../../LinkyLinky';
import { InvitationResource } from '../../../../../Store/Types';

interface Props {
  resource: InvitationResource;
}

function Row({ resource }: Props) {
  return (
    <div className="flex py-4 gap-2 items-center">
      <div className="flex" data-test-person={true}>
        <div
          className="relative h-10 w-10 min-w-[100%] rounded-full bg-[#187A90]"
          data-test-person-avatar={true}
        >
          <PersonPhoto
            avatar={avatarFrom(findLink('avatar', resource.links), resource.payload.initials)}
          />
        </div>
      </div>
      <span>
        <div>
          <NotTranslated text={resource.payload.name} />
        </div>
        <div className="text-sm">
          <NotTranslated text={resource.payload.email} />
        </div>
      </span>
    </div>
  );
}

export default observer(Row);
